<div class="mb-12" *ngIf="!field.hide">
  <app-setting-item-view [heading]="field.title | translate" [description]="field.description | translate" [value]="selectedValue" >
    <button mat-raised-button (click)="selectTemplate()" > {{ 'ct.select_template' | translate }} </button>
  </app-setting-item-view>
</div>